module.exports = __webpack_public_path__ + "img/becIns-MobileDp.d6efeee8.svg";